import {GetSaSeung, GetSeungJo, IsJangDanChar} from '../defines/gukeo.func';
import {CHAR_STRUCT, CHAR_TYPE, WORD_STRUCT} from '../defines/client.const';
import {GetLastNumber, IsEmptyString, IsHanja} from '../defines/common.func';
import {getRecorderType, RECORDER_TYPE, SASEUNG, SEUNGJO_MIDDLE, WORD_SEPARATOR_NUM} from '../defines/gukeo.const';
import {WORD_ITYPE} from '../defines/pitch.const';
import {getWordIType} from '../defines/pitch.func';

export class SimpleWord {
  id: string;
  word1: string;
  hangul2: string;
  intonation: Array<number>;
  intonation2: Array<number>;
  fourTones: Array<SASEUNG>;
  level: number;
  meaning: Array<string> | null;
  wordVoice: string;
  highlight: string | null;
  correct: string | null;
  correctIds: Array<string> | null;

  wordStruct: WORD_STRUCT;  // 단어를 화면에 표시하기위한 구조 데이터 (한글, 성조, 장단 + 한자 사성 정보를 구조적으로 저장)

  offsetTop?: number; // 단어가 화면에 표시되는 위치 (단어가 화면에 표시되는 위치를 저장한다. 속도 향상을 위해서 저장.)


  constructor(obj?: any) {
    this.id                 = (obj && obj.id)                 ?? null;
    this.word1              = (obj && obj.word1)              ?? null;
    this.hangul2            = (obj && obj.hangul2)            ?? null;
    this.intonation         = (obj && obj.intonation)         ? GetSeungJo(obj.intonation) : null;
    this.intonation2        = (obj && obj.intonation2)        ? GetSeungJo(obj.intonation2) : null;
    this.fourTones          = (obj && obj.four_tones)         ? GetSaSeung(obj.four_tones) : null;
    this.level              = (obj && obj.level)              ?? null;
    this.meaning            = (obj && obj.meaning2)           ? String(obj.meaning2).split(WORD_SEPARATOR_NUM) : null;
    this.wordVoice          = (obj && obj.word_voice)         ?? null;
    this.highlight          = obj.highlight                   ?? null;
    this.correct            = obj.correct                     ?? null;
    this.correctIds         = (obj && obj.correct_ids)        ? String(obj.correct_ids).split(',') : null;

    this.makeWordStruct();
  }

  public get recorder(): RECORDER_TYPE {
    if (this.wordVoice) {
      const regEx = '[a-z][.]mp3$';
      const match = this.wordVoice.match(regEx);
      return match ? getRecorderType(this.wordVoice.substr(match.index, 1)) : RECORDER_TYPE.RECORDER_A;
    }
    return RECORDER_TYPE.RECORDER_A;
  }

  public get iType(): WORD_ITYPE {
    return getWordIType(this.intonation);
  }

  // 이운이의어 번호를 얻는 함수
  // 0 이면 없음.
  public get idxHomonym(): number {
    return GetLastNumber(this.id);
  }

  /**
   * 단어를 화면에 표시하기위한 데이터 wordStruct 설정하는 함수
   * 한글, 성조, 장단 + 한자 사성 정보를 구조적으로 저장
   */
  private makeWordStruct(): void {
    const wordStruct: WORD_STRUCT = new Array<CHAR_STRUCT>();

    let lastType: CHAR_TYPE = null;

    let i = 0;  // 한글 index
    let h = 0;  // 한자 index
    for (const char of this.word1) {
      // console.log('char:', char);

      if (IsJangDanChar(char)) {
        const cs: CHAR_STRUCT = {
          type: CHAR_TYPE.JANGDAN,
          char,
        };

        wordStruct.push(cs);
      }
      else if (IsHanja(char)) {
        // TODO: [임시 처리, 개선 요망] 사성이 존재하지 않는 경우에는 오류이다. 오류인 경우 SASEUNG.NONE을 넣고 표시하지 않는다.
        const saseung = this.fourTones && this.fourTones.length > h ? this.fourTones[h] : SASEUNG.NONE;

        const wordChar: CHAR_STRUCT = {
          type: CHAR_TYPE.HANJA,
          char,
          saseung,
          firstHanja: lastType === CHAR_TYPE.HANGUL,  // 첫번째 안자 (이전 글자가 한글이면 true)
        };

        wordStruct.push(wordChar);
        lastType = CHAR_TYPE.HANJA;
        ++h;
      }
      else {
        // WARN: [주의] 성조 배열의 길이가 짧아서 문제가 되면 SASEUNG.NONE 를 넣음 --> 성조가 안보이게 처리함.
        const seungjo = this.intonation?.length > i ? this.intonation[i] : SASEUNG.NONE;
        const seungjo2 = this.intonation2?.length > i ? this.intonation2[i] : SASEUNG.NONE;

        const wordChar: CHAR_STRUCT = {
          type: CHAR_TYPE.HANGUL,
          char,
          seungjo,
          seungjo2, // 허용되는 성조
        };

        wordStruct.push(wordChar);
        lastType = CHAR_TYPE.HANGUL;
        ++i;
      }
    }

    // console.log('makeWordStruct():', this.word1, wordStruct);
    this.wordStruct = wordStruct;
  }

  public GetMeaningNth(nth: number): string | null {
    const meaning = this.meaning?.[nth] ?? null;
    return IsEmptyString(meaning) ? null : meaning;
  }

  public GetBriefMeaning(): string | null {
    return this.meaning
      // .filter(m => !IsEmptyString(m))
      ?.map((m, index) => index === 0 ? m : ` ${index}.${m}`)
      .join('') ?? null;
  }
}
